import { requestPost, requestGet, requestFormPost } from '@/common/request';
import {
  ASSIGN_LIST_TYPE,
  PROMO_LIST_TYPE,
} from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection/sale-strategy-list/list-hooks';

export interface materialGroupItem {
  id: string;
  name: string;
  type: string;
  source: string;
  materialNum: number;
  displayNum: number;
  displayRule: string;
  erpNo: string;
  status: number;
  position: string;
}
export interface materialListRes {
  code: string;
  subCode: string;
  erpNo: string;
  msg: string;
  list: materialGroupItem[];
}
export interface materialListParams {
  search?: string;
}

export async function queryMaterialList(params: materialListParams): Promise<materialListRes> {
  return await requestPost(
    'http://zero-mock.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/marketing-field/materialList',
    params
  );
}

/**
 * @description 促销商品策略列表 https://cf.jd.com/pages/viewpage.action?pageId=789316939
 */
export interface PromoStrategyItem {
  /**
   * 策略id
   */
  id: number;
  /**
   * 策略名称
   */
  name: string;
  /**
   * 阵地id
   */
  positionId: string;
  /**
   * 例如：综促创建的促销活动id
   */
  outerId: number;
  /**
   * 类型 规则圈选-4 分配提报-1 或 2
   */
  assignType: ASSIGN_LIST_TYPE;
  /**
   * 促销类型 单品促销-104 折扣促销-110
   */
  promoType: PROMO_LIST_TYPE;
  /**
   * 促销力度
   */
  benefitDesc: string;
  /**
   * 已报名数量
   */
  usedCount: number;
  /**
   * 可报名数量 若是部门分配，此字段为null
   */
  receivedCount: number;
  /**
   * 策略说明
   */
  strategyDesc: string;
  /**
   * 创建人
   */
  createPin: string;
  /**
   * 创建人名称
   */
  createPinName: string;
}

export interface promoStrategyListRes {
  code: string;
  subCode: string;
  erpNo: string;
  msg: string;
  data: {
    items: PromoStrategyItem[];
    page: number;
    pageSize: number;
    totalCount: number;
    totalPage: number;
  };
}

export interface promoStrategyListParams {
  /**
   * 阵地id
   */
  positionId: string;
  /**
   * 策略id
   */
  id?: string;
  /**
   * 策略名称
   */
  name?: string;
  /**
   * 页码
   */
  page: number;
  /**
   * 页容
   */
  pageSize: number;
}

export async function queryPromoStrategyList(params: promoStrategyListParams): Promise<promoStrategyListRes> {
  return await requestFormPost('/generic/mac/strategy/queryPromoStrategyList', params);
  //   return await requestPost(
  //     'http://zero-mock.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/marketing-field/queryPromoStrategyList',
  //     params
  //   );
}

/**
 * @description 商品策略列表 https://cf.jd.com/pages/viewpage.action?pageId=788079499
 */
export interface GoodsStrategyItem {
  /**
   * 策略id
   */
  jobId: number;
  /**
   * 策略名称
   */
  jobName: string;
  /**
   * 策略说明
   */
  jobDescription: string;
  /**
   * 创建人
   */
  createBy: string;
  /**
   * 创建人名称
   */
  createdByCN: string;
  /**
   * 商品数
   */
  wareCount: number;
  /**
   * 类型 规则圈选-4 分配提报-1 或 2
   */
  type: ASSIGN_LIST_TYPE;
  /**
   * 子策略
   */
  ruleGroups: ChildRuleGroups[];
}

export interface ChildRuleGroups {
  /**
   * 子策略id
   */
  ruleGroupId: number;
  /**
   * 子策略名称
   */
  ruleGroupName: string;
}
export interface goodsStrategyListRes {
  ret: string;
  erpNo: string;
  msg: string;
  data: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
    data: GoodsStrategyItem[];
  };
}

export interface goodsStrategyListParams {
  /**
   * 阵地id/日常活动id
   */
  channelId: string;
  /**
   * 9-阵地；11-日常活动
   */
  channelType: number;
  /**
   * 策略id
   */
  jobId?: number;
  /**
   * 策略名称
   */
  jobName?: string;
  /**
   * 当前页数
   */
  pageNo: number;
  /**
   * 每页大小
   */
  pageSize: number;
}

export async function queryGoodsStrategyList(params: goodsStrategyListParams): Promise<goodsStrategyListRes> {
  return await requestGet('/ware/goodsStrategyList', params);
  //   return await requestGet('http://zero-mock.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/ware/goodsStrategyList', params);
}

export interface ActivityJobInfoListResponse {
  data: {
    code: string;
    subCode: string;
    returnMsg: string;
    data: string;
  };
  ret: string;
  msg: string;
}

export async function queryDucc(params: { duccKey: string }): Promise<ActivityJobInfoListResponse> {
  return await requestFormPost('/generic/sourcecms/materialManage/duccInfo', { body: JSON.stringify(params) });
}

export const materialCollection = {
  queryMaterialList,
  queryPromoStrategyList,
  queryGoodsStrategyList,
  queryDucc,
};
